<template>
  <qd-loader :active="isLoading">
    <div class="columns mgb-20px" :class="{ 'min-height-100': isLoading }">
      <div class="column is-2 card mg-10px is-cursor-pointer"
          v-for="etat in regroupementEtat" :key="etat.code"
          @click="$emit('changeEtat', etat.code)">
          <div class="columns">
            <div class="column is-12 mgl-10px is-flex is-vcentered">
              <b-icon
                icon="checkbox-blank-circle"
                :custom-class="getCouleurInformation(etat.code).type"
                size="is-medium"
              ></b-icon>
              &nbsp;&nbsp;
              <span class="is-size-4 has-text-weight-semibold">
                <span class="has-text-primary lien">
                  {{ getLibelleEtat(etat.code) }}
                </span> :
                {{ getNombreOtByEtat(etat) }}
              </span>
            </div>
          </div>
          <div class="mg-10px">
            <div v-for="materielType in etat.otImpressionEtatMaterielTypes"
                  :key="`${etat.code}-${materielType.materielTypeId}`">
              <span>
                {{ getMaterielType(materielType.materielTypeId) }} :
                 {{ materielType.materielTypeCount }}
              </span>
            </div>
          </div>
      </div>
    </div>
  </qd-loader>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getAllResume } from '@/api/logistique/ordreTravailImpression/index';
import messageErreur from '@/services/general/messageErreur';
import {
  LIST_ETAT_OT_TECH,
  ETAT_EN_COURS,
  ETAT_REALISE,
  COULEUR_OT_ETAT,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

const Parametres = createNamespacedHelpers('parametres');
const OrdreTravailImpression = createNamespacedHelpers('ordreTravailImpression');

export default {
  name: 'resumeDemandeImpression',
  data() {
    return {
      isLoading: false,
      regroupementEtat: [],
      enCours: [],
      realises: [],
      constantes: {
        ETAT_EN_COURS,
        ETAT_REALISE,
        COULEUR_OT_ETAT,
      },
    };
  },
  computed: {
    ...OrdreTravailImpression.mapGetters({
      lastPayload: 'lastPayload',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    listeEtat() {
      return LIST_ETAT_OT_TECH.filter(etat => etat === ETAT_EN_COURS || etat === ETAT_REALISE);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getLibelleEtat(etatOt) {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === etatOt;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    getNombreOtByEtat(etatOt) {
      let nombreOtbyEtat = 0;
      etatOt.otImpressionEtatMaterielTypes.forEach(otImpressionEtatMaterielTypes => {
        nombreOtbyEtat += otImpressionEtatMaterielTypes.materielTypeCount;
      });
      return nombreOtbyEtat;
    },
    getMaterielType(typeId) {
      const materielTypeFind = this.parametre(PARAMETRES_KEYS.materielType)
        .find((type) => {
          return type.id === typeId;
        });
      return materielTypeFind ? materielTypeFind.libelle : this.$t('listeOtImpression.resume.sansMaterielType');
    },
    getCouleurInformation(otEtat) {
      return this.constantes.COULEUR_OT_ETAT.find(
        (couleurOtEtat) => otEtat === couleurOtEtat.key,
      );
    },
    async refresh() {
      this.isLoading = true;
      try {
        await this.loadParametres([
          PARAMETRES_KEYS.materielType,
        ]);
        const paylaod = cloneDeep(this.lastPayload);
        paylaod.limit = NO_PAGINATION;
        const response = (await getAllResume(paylaod)).data.result;
        this.regroupementEtat = response;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>
